// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../../common/input';

export default function CamposTributosDevolvidos() {
  return (
      <FormSection name="dadosTributosDevolvidos">
        <SelecaoTodosNfe nomes={ ["dadosTributosDevolvidos"] } titulo="Tributos Devolvidos"/>

        <div className="grupo-checkbox">
          <Input name="percMercDevolvidaTribDevolvidos" label="% Mercadoria Devolvida" checkbox/>
          <Input name="ipiDevolvidoTribDevolvidos" label="IPI Devolvido" checkbox/>
        </div>
      </FormSection>
  );
}